/**
 * useTableAccount — manages table account data fetching and related tables list.
 * Extracted from TableDetail.js for reuse and modularity.
 */
import { useState, useEffect, useCallback, useRef } from "react";

export function useTableAccount(authAxios, table, initialRestaurantData = null) {
  const [account, setAccount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [allTables, setAllTables] = useState([]);
  const [restaurantData, setRestaurantData] = useState(initialRestaurantData);

  const authAxiosRef = useRef(authAxios);
  authAxiosRef.current = authAxios;

  const fetchAccount = useCallback(() => {
    authAxiosRef.current
      .get(`/tables/${table.id}/account`)
      .then((res) => { setAccount(res.data); setLoading(false); })
      .catch(() => setLoading(false));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [table.id]);

  useEffect(() => { fetchAccount(); }, [fetchAccount]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    authAxiosRef.current
      .get("/tables")
      .then((res) => setAllTables(res.data.filter((t) => t.id !== table.id)))
      .catch(() => {});
  }, [table.id]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (initialRestaurantData) return; // already have it from prop
    authAxiosRef.current.get("/restaurant").then((res) => {
      const data = res.data?.data || res.data;
      setRestaurantData(data);
    }).catch(() => {});
  }, [initialRestaurantData]);

  return { account, loading, fetchAccount, allTables, restaurantData, setRestaurantData };
}
